import "@/assets/scss/app.scss";
import "floating-vue/dist/style.css";

import App from "./App.vue";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { createApp } from "vue";
import { createPinia } from "pinia";
import FloatingVue, { Menu as VMenu } from "floating-vue";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import mitt from "mitt";

import { register } from "swiper/element/bundle";

declare global {
  interface Window {
    auction_id: number;
    Pusher: typeof Pusher;
    Echo: Echo;
  }
}
window.Pusher = Pusher;

window.Echo = new Echo({
  broadcaster: "pusher",
  key: process.env.VUE_APP_PUSHER_APP_KEY || "localhost",
  wsHost: process.env.VUE_APP_PUSHER_APP_HOST || "127.0.0.1",
  wsPort: process.env.VUE_APP_PUSHER_APP_PORT || 6001 || 80,
  wssPort: process.env.VUE_APP_PUSHER_APP_PORT || 443,
  wsPath: "/ws",
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER || "mt1",
  encrypted: true,
  forceTLS: false,
  disableStats: true,
  enabledTransports: ["ws", "wss"]
});
const emitter = mitt();

const app = createApp(App);

register();
app.component("v-menu", VMenu);
app.use(createPinia());
app.use(FloatingVue, {
  themes: {
    "info-tooltip": {
      $extend: "menu",
      $resetCss: true,
      delay: 100,
      strategy: "fixed",
      triggers: ["hover", "click", "touch"]
    },
    "info-tooltip-click": {
      $resetCss: true,
      triggers: ["click"],
      autoHide: true
    },
    "info-dropdown": {
      $resetCss: true
    },
    "info-tooltip-menu": {
      $extend: "menu",
      $resetCss: true,
      delay: 100,
      autoHide: true,
      strategy: "fixed",
      triggers: ["hover", "click", "touch"]
    },
    "info-tooltip-without-arrow": {
      $resetCss: true,
      strategy: "fixed",
      triggers: ["hover", "click", "touch"]
    },
    "info-menu-without-arrow": {
      $extend: "info-tooltip"
    }
  }
});

app.use(PrimeVue);
app.use(ToastService);

app.provide("emitter", emitter);

app.mount("#app");
